import React from 'react';
import { Evenement } from '../../interfaces/article';
import { Select, MenuItem } from '@material-ui/core';
import ArticleField from '../ArticleField';

interface EvenementPickerProps {
	value: Evenement,
	onChange: (newValue: Evenement) => void,
}

const EvenementPicker = (props: EvenementPickerProps) => {
	return <ArticleField label="Evenement">
		<Select
			value={props.value}
			onChange={(e) => {
				props.onChange(e.target.value as Evenement);
			}}>
			<MenuItem value={'Pasdevenement'}>Pasdevenement</MenuItem>
			<MenuItem value={'Scoop'}>Scoop</MenuItem>
			<MenuItem value={'Urgent'}>Urgent</MenuItem>
			<MenuItem value={'Infoatlantico'}>Infoatlantico</MenuItem>
		</Select>
	</ArticleField>
}

export default EvenementPicker;